import { effect, Injectable, inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { UserStore } from '../store/user.store';
import { AuthStore } from '../store';
import { OrganizationService } from '../services/organization.service';
import { NotificationSettingsStore } from '../store/notification-settings.store';

@Injectable({ providedIn: 'root' })
export class AppInitService {
  private authService = inject(AuthService);
  private userStore = inject(UserStore);
  private authStore = inject(AuthStore);
  private organizationService = inject(OrganizationService);
  private notificationSettingsStore = inject(NotificationSettingsStore);

  constructor() {
    this.listenToOrganizationSelection();
  }

  async initialize(): Promise<void> {
    try {
      await this.authService.initializeAuth();
      if (this.authStore.isAuthenticated()) {
        await this.userStore.loadStartData();
        this.userStore.loadPersistedOrganizationSelection();
        void this.notificationSettingsStore.restorePushSubscriptionOnStartup();
      }
    } catch (error) {
      console.error('Failed to initialize application:', error);
    }
  }

  private async listenToOrganizationSelection(): Promise<void> {
    effect(async () => {
      if (this.userStore.currentOrganization() && this.authStore.isAuthenticated()) {
        setTimeout(async () => {
          this.organizationService.fetchProducts();
          this.organizationService.getUsers();
        });
      }
    });
  }
}
